export var TeamFundraisingRole;
(function (TeamFundraisingRole) {
    TeamFundraisingRole["TEAM_MEMBER"] = "Team Member";
    TeamFundraisingRole["TEAM_CAPTAIN"] = "Team Captain";
})(TeamFundraisingRole || (TeamFundraisingRole = {}));
